import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route: /experiences/* children (event detail pages) render through here.
// The experiences list itself lives at ./experiences/index.tsx ("/experiences/").
export const Route = createFileRoute("/experiences")({
  component: () => <Outlet />,
});
